import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1bd10jxt4j: FaireBrandEntity = {
  token: "b_1bd10jxt4j",
  type: "brand",
  name: "MT Brand Apparel",
  avatarUrl: "https://cdn.faire.com/fastly/4d70213c1434cd0da22a7ec0c98ed4194f758c1a18ea0c0681eaedff1e92c181.png",
  bannerUrl: "https://cdn.faire.com/fastly/1eea84447ab40b6ab361c30ebfb06f9f3cd6923f8b3c674e978b64e82e04d00a.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/4d70213c1434cd0da22a7ec0c98ed4194f758c1a18ea0c0681eaedff1e92c181.png",
  heroImageUrl: "https://cdn.faire.com/fastly/1eea84447ab40b6ab361c30ebfb06f9f3cd6923f8b3c674e978b64e82e04d00a.jpeg",
  location: "Stevensville, MT, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 225,
  isTopShop: true,
  isInsider: true,
  description: "What started as a sticker design for a friend, MT Brand Apparel has grown into a nationwide retail wholesaler for state specific products, distributed by boutiques and retail stores across the country. Our clean, simple designs set us apart and builds brand loyalty. \n \nOur heart is with the small business owner. We want our customers to become our friends and we are always thinking out of the box to bring the right product in the right amounts to our wholesale customers.  \n\nMT Brand Apparel is run by Wendy Jordan, a second-generation Montana native.  A family affair; MT Brand Apparel is headquartered in the gorgeous Bitterroot Valley in Stevensville, MT where Wendy lives with her husband, children, four horses and four dogs .  Wendy enjoys books, coffee, podcasts, journaling and spending time in nature.  The simplicity of life in beautiful Montana provides Wendy and her Husband the inspiration for all of MT Brand Apparel’s designs.  \n",
  meta: {
    source: "api",
    importedAt: "2026-10-09T07:53:33.156Z",
    importedBy: "entity-db-cli"
  }
};
